export default defineNuxtRouteMiddleware(async (to) => {
  const publicPaths = new Set<string>([ '/forbidden' ]) // '/login' , '/signed-out'
  // ignore Nuxt internals + your API routes
  if (to.path.startsWith('/api/')) return
  if (publicPaths.has(to.path)) return

  const headers = process.server ? useRequestHeaders(['cookie']) : undefined
  const { data } = await useFetch('/api/auth/me', { headers, credentials: 'include' })

  if (!data.value?.authenticated) {
    const returnTo = encodeURIComponent(to.fullPath)
    let redirect = ''//'/household/overview'
    await navigateTo(`/api/auth/login?returnTo=${encodeURIComponent(redirect)}`, { external: true })
  }
})
